module.exports = __webpack_public_path__ + "img/img2.56d5f803.png";